var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from '~/components/common/data-box.vue';
import SideAnchorMenu from "~/components/SideAnchorMenu/index.vue";
import { Dependencies } from "~/core/decorator";
import { State, namespace } from "vuex-class";
import FileUpload from "~/components/common/file-upload.vue";
var CollectionExecutionModule = namespace('collection-execution');
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import { MENU_CHANNEL } from "~/config/enum.config";
/**
 * 法务行动记录 流程详情
 */
var LegalUrgeActionFlow = /** @class */ (function (_super) {
    __extends(LegalUrgeActionFlow, _super);
    function LegalUrgeActionFlow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.operatorId = "edit";
        //数据
        _this.formLegalData = {
            id: "",
            //立案数据
            legalHandleType: "",
            plaintiffInformation: "",
            personalName: "",
            idCard: "",
            courtName: "",
            indexNumber: "",
            isSafe: "",
            safeAmount: "",
            lawsuitFee: "",
            noticeFee: "",
            belongName: "",
            legalArchivesNo: "",
            legalArchivesPlace: "",
            legalCaseNo: "",
            legalCasePlace: "",
            registerRemark: "",
            lawsuitAmount: "",
            // 开庭数据
            comeUpTime: "",
            comeUpPlace: "",
            comeUpName: "",
            judgeName: "",
            judgePhone: "",
            courtTrialResults: "",
            legalInstrumentDate: "",
            effectiveDate: "",
            comeUpRemark: "",
            // 执行数据
            beExecutor: "",
            executeDate: "",
            executeCourtName: "",
            executeNumber: "",
            executeObject: "",
            executeJudgePhone: "",
            assessCompanyName: "",
            assessCompanyPhone: "",
            executeAmount: "",
            assessAmount: "",
            auctionAmount: "",
            carTransactionAmount: "",
            executeRemark: "",
            // 结案数据验证
            closeCaseCause: "",
            advanceAmount: "",
            costAmount: "",
            backAmount: "",
            differenceAmount: "",
            closeCaseRemark: "",
            // 附件
            fileRemark: "",
            fileIds: []
        };
        //数据验证
        _this.formLegalRules = {
            //立案数据验证
            legalHandleType: [{ required: true, message: "请选择处理方式", trigger: 'blur' }],
            plaintiffInformation: [{ required: true, message: "请选择原告信息" }],
            personalName: [{ required: true, message: "请输入被告人姓名" }],
            idCard: [{ required: true, message: "请输入身份证号" }],
            courtName: [{ required: true, message: "请输入法院/仲裁委" }],
            // indexNumber: [{ required: true, message: "请输入案号" }],
            // isSafe: [{ required: true, message: "请选择是否保全" }],
            // 开庭数据验证
            comeUpTime: [{ required: true, message: "请输入开庭时间", trigger: 'blur' }],
            comeUpPlace: [{ required: true, message: "请输入开庭地点", trigger: 'blur' }],
            comeUpName: [{ required: true, message: "请输入开庭人", trigger: 'blur' }],
            judgePhone: { validator: _this.$validator.phoneNumber, trigger: 'blur' },
            // 执行数据验证
            beExecutor: [{ required: true, message: "请输入被执行人", trigger: 'blur' }],
            executeDate: [{ required: true, message: "请选择执行立案时间", trigger: 'blur' }],
            executeCourtName: [{ required: true, message: "请输入执行立案法院", trigger: 'blur' }],
            executeNumber: [{ required: true, message: "请输入执行案号", trigger: 'blur' }],
            executeObject: [{ required: true, message: "请输入执行标的", trigger: 'blur' }],
            // 结案数据验证
            closeCaseCause: [{ required: true, message: "请选择结案原因", trigger: 'blur' }]
        };
        //执行立案法院
        _this.options5 = [];
        _this.fileList = [];
        _this.enclosureDataSet = [];
        _this.fileSrcList = [];
        _this.submitLoading = false;
        _this.anchorMenus = [
            {
                text: '立案',
                onClick: function () { return _this.anchorPosition('#legal-filing'); }
            }, {
                text: '开庭',
                onClick: function () { return _this.anchorPosition('#legal-hold-court'); }
            }, {
                text: '执行',
                onClick: function () { return _this.anchorPosition('#legal-implement'); }
            }, {
                text: '结案',
                onClick: function () { return _this.anchorPosition('#legal-close-case'); }
            }, {
                text: '附件',
                onClick: function () { return _this.anchorPosition('#legal-enclosure'); }
            }
        ];
        return _this;
    }
    //获取立案数据
    LegalUrgeActionFlow.prototype.showLegalInfoById = function (val) {
        var _this = this;
        this.caseOperatorPageService
            .queryCaseLegalRecordById(val)
            .subscribe(function (data) {
            if (data) {
                _this.formLegalData = __assign({}, data);
                // if (data.isComeUp === "YES") {
                //   this.formLegalData.comeUpName = data.comeUpName;
                // }else{
                //   this.formLegalData.comeUpName = "";
                // }
                // 执行
                // if (data.isExecute === "YES") {
                //   this.formLegalData.beExecutor = data.beExecutor;
                // }else{
                //   this.formLegalData.beExecutor = "";
                // }
                // 删除多余的legalFiles字段
                delete _this.formLegalData.legalFiles;
                // 附件
                _this.enclosureDataSet = data.legalFiles;
                _this.enclosureDataSet.forEach(function (item) {
                    _this.fileSrcList.push(item.fileUrl);
                });
            }
        }, function (err) {
        });
    };
    LegalUrgeActionFlow.prototype.scrollTo = function (offsetTop) {
        var parent = document.querySelector('#app');
        parent.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    };
    LegalUrgeActionFlow.prototype.anchorPosition = function (anchor_id) {
        var anchor = this.$el.querySelector(anchor_id); //获取元素
        anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    };
    //查询执行立案法院名称去重
    LegalUrgeActionFlow.prototype.queryExecuteCourtName = function () {
        var _this = this;
        //查询执行立案法院名称去重
        this.caseOperatorPageService.queryExecuteCourtName()
            .subscribe(function (data) {
            if (data) {
                _this.options5 = data;
            }
        }, function (err) {
        });
    };
    LegalUrgeActionFlow.prototype.onUploadRemove = function (file, fileList) {
        this.fileList = fileList;
    };
    //保存
    LegalUrgeActionFlow.prototype.onSubmit = function () {
        var _this = this;
        var form = this.$refs["form-legal-ref"];
        this.submitLoading = true;
        // form.validate((valid:boolean) => {
        //   if (!valid){
        //     this.submitLoading=false
        //     this.$message.error("请填写必填项");
        //     return false;
        //   }
        var formData = __assign({}, this.formLegalData);
        if (this.menuChannel === MENU_CHANNEL.Assist_legal) {
            formData.assistId = this.otherData.assistId;
        }
        //
        if (formData.isSafe === "") {
            formData.isSafe = null;
        }
        //
        formData.caseId = this.caseId;
        //开庭时间
        if (formData.comeUpTime) {
            formData.comeUpTime = this.$filter.dateTimeFormat(formData.comeUpTime);
        }
        if (formData.effectiveDate) {
            formData.effectiveDate = this.$filter.dateFormat(formData.effectiveDate);
        }
        if (formData.legalInstrumentDate) {
            formData.legalInstrumentDate = this.$filter.dateFormat(formData.legalInstrumentDate);
        }
        // 执行
        if (formData.executeDate) {
            formData.executeDate = this.$filter.dateTimeFormat(formData.executeDate);
        }
        //附件
        if (this.fileList && this.fileList.length > 0) {
            if (!this.formLegalData.fileIds) {
                this.formLegalData.fileIds = [];
            }
            if (!formData.fileIds) {
                formData.fileIds = [];
            }
            this.fileList.forEach(function (element) {
                if (element.response) {
                    var file = {};
                    file.legalId = _this.formLegalData.id;
                    file.fileId = element.response.id;
                    file.fileName = element.response.originalName;
                    file.fileRemark = _this.formLegalData.fileRemark;
                    file.fileUrl = element.response.url;
                    _this.formLegalData.fileIds.push(file);
                    //添加到formData
                    formData.fileIds.push(file);
                }
            });
        }
        this.caseOperatorPageService.addCaseLegalRecord(formData)
            .subscribe(function (data) {
            // form.resetFields();
            // this.fileList = []
            // this.formLegalData.id = "";
            //this.emitSuccess();
            _this.$message.success('法催催记立案已添加成功，如需修改请在法务详情中进行修改');
            _this.submitLoading = false;
        }, function (err) {
            _this.submitLoading = false;
        });
        // })
    };
    // 取消
    LegalUrgeActionFlow.prototype.onCancel = function () {
        window.close();
    };
    LegalUrgeActionFlow.prototype.mounted = function () {
        this.legalRecordId = this.$route.query.id;
        this.operatorId = this.$route.query.operatorId || "edit";
        this.queryExecuteCourtName();
        this.showLegalInfoById(this.legalRecordId);
    };
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeActionFlow.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeActionFlow.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], LegalUrgeActionFlow.prototype, "otherData", void 0);
    __decorate([
        State
    ], LegalUrgeActionFlow.prototype, "userData", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], LegalUrgeActionFlow.prototype, "caseOperatorPageService", void 0);
    LegalUrgeActionFlow = __decorate([
        Component({
            components: {
                FileUpload: FileUpload,
                DataBox: DataBox,
                SideAnchorMenu: SideAnchorMenu
            }
        })
    ], LegalUrgeActionFlow);
    return LegalUrgeActionFlow;
}(Vue));
export default LegalUrgeActionFlow;
